module.exports = __webpack_public_path__ + "static/media/logo.c7f285f6.png";